import { DesignType } from "../../Interfaces/FundraiserRole";

// Helper to maintain insertion order
class OrderedSet<T> extends Set<T> {
  private order: T[] = [];

  add(value: T): this {
    if (!this.has(value)) {
      this.order.push(value);
    }
    super.add(value);
    return this;
  }

  toArray(): T[] {
    return this.order.filter((item) => this.has(item));
  }
}

export const dynamicCategoryDesignFetcher = (
  designs: DesignType[]
): Record<string, string[]> => {
  const categoryMap: Record<string, OrderedSet<string>> = {};
  const categoryOrder: string[] = [];

  designs.forEach((designType) => {
    Object.entries(designType).forEach(([categoryName, subCategories]) => {
      if (!categoryMap[categoryName]) {
        categoryMap[categoryName] = new OrderedSet<string>();
        if (!categoryOrder.includes(categoryName)) {
          categoryOrder.push(categoryName);
        }
      }

      Object.entries(subCategories).forEach(([subCategoryName]) => {
        if (subCategoryName === "__no_subcategory__") {
          categoryMap[categoryName] = new OrderedSet<string>();
        } else if (subCategoryName) {
          categoryMap[categoryName].add(subCategoryName);
        }
      });
    });
  });

  const result: Record<string, string[]> = {};
  categoryOrder.forEach((category) => {
    if (categoryMap[category]) {
      result[category] = categoryMap[category].toArray();
    }
  });

  return result;
};

export default dynamicCategoryDesignFetcher;
